var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tabClass},[_c('ul',{class:_vm.navClass},[_vm._t("link")],2),_c('div',{staticClass:"tab-content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }